var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.107,
    height: 58.81,
    viewBox: "0 0 44.107 58.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5406",
    "data-name": "Group 5406",
    transform: "translate(-1015 -544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "padlock",
    transform: "translate(1012 544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M41.594,45.756H8.513A5.52,5.52,0,0,1,3,40.243V14.513A5.52,5.52,0,0,1,8.513,9h33.08a5.52,5.52,0,0,1,5.513,5.513V40.243A5.52,5.52,0,0,1,41.594,45.756ZM8.513,12.676a1.84,1.84,0,0,0-1.838,1.838V40.243A1.84,1.84,0,0,0,8.513,42.08h33.08a1.84,1.84,0,0,0,1.838-1.838V14.513a1.84,1.84,0,0,0-1.838-1.838Z",
    transform: "translate(0 13.054)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    "data-name": "Path 3132",
    d: "M33.567,25.729a1.838,1.838,0,0,1-1.838-1.838V14.7a11.027,11.027,0,1,0-22.054,0v9.189a1.838,1.838,0,1,1-3.676,0V14.7a14.7,14.7,0,1,1,29.4,0v9.189A1.838,1.838,0,0,1,33.567,25.729Z",
    transform: "translate(4.351)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3133",
    "data-name": "Path 3133",
    d: "M14.9,22.8a4.9,4.9,0,1,1,4.9-4.9A4.906,4.906,0,0,1,14.9,22.8Zm0-6.126A1.225,1.225,0,1,0,16.126,17.9,1.227,1.227,0,0,0,14.9,16.676Z",
    transform: "translate(10.153 18.855)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M13.088,26.164a1.838,1.838,0,0,1-1.838-1.838V17.588a1.838,1.838,0,1,1,3.676,0v6.739A1.838,1.838,0,0,1,13.088,26.164Z",
    transform: "translate(11.966 22.844)",
    fill: "#90205d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.92f2580a.svg";
export { ForwardRef as ReactComponent };